export const PUSHER = {
  ENABLED: process.env.VUE_APP_PUSHER_ENABLED,
  API_KEY: `${process.env.VUE_APP_PUSHER_API_KEY}`,
  CLUSTER: 'us3',
  CHANNEL: 'lighthouse-subscription'
};
